import { __assign, __extends } from "tslib";
import React from 'react';
import { childrenOfType } from 'airbnb-prop-types';
import { NavStepper as CoreNavStepper, } from 'wix-ui-core';
import { st, classes } from './NavStepper.st.css';
var NavStepper = /** @class */ (function (_super) {
    __extends(NavStepper, _super);
    function NavStepper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavStepper.prototype.render = function () {
        return (React.createElement(CoreNavStepper, __assign({}, this.props, { className: st(classes.root, { fontUpgrade: this.props.fontUpgrade }, this.props.className) }), React.Children.map(this.props.children, function (child, index) {
            if (React.isValidElement(child)) {
                return (React.createElement(CoreNavStepper.Step, __assign({}, child.props),
                    React.createElement("span", { className: classes.stepCheck }),
                    React.createElement("span", { className: classes.stepPrefix }, index + 1 + "."),
                    child.props.children));
            }
            return child;
        })));
    };
    NavStepper.Step = CoreNavStepper.Step;
    NavStepper.propTypes = {
        children: childrenOfType(CoreNavStepper.Step),
    };
    return NavStepper;
}(React.PureComponent));
export { NavStepper };
//# sourceMappingURL=NavStepper.js.map